import axios from "axios";
import { API_URL } from "../const";
/** ***************** UPDATE PASSWORD START *********************** */
export const passwordUpdate = (updatPasswordData: any) => {
  const data = {
    UpdatePasswordToken: updatPasswordData,
  };
  const url = `${API_URL}UpdateProfilePassword`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
/** ***************** UPDATE PASSWORD   END *********************** */

/*************** PROFILE IMAGE DETAILS UPDATE START *************** */
export const profileImageDetailsUpdate = (updateData: any) => {
  const data = {
    UpdateProfileToken: updateData,
  };
  const url = `${API_URL}UpdateProfile`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
/*************** PROFILE IMAGE DETAILS UPDATE END *************** */
